"use strict";
import * as React from "react";
import "./MapView.css";

export interface MapViewProps extends React.SVGProps<SVGSVGElement> {
    countryAlpha3Code: string;
    regions: {
        [key: string]: {
            value: string;
            bin: number;
            color: string;
        };
    };
}

export class MapView extends React.Component<MapViewProps, any> {
    constructor(props: MapViewProps) {
        super(props);
    }

    shouldComponentUpdate(nextProps: MapViewProps) {
        const strProps = JSON.stringify(this.props);
        const strNextProps = JSON.stringify(nextProps);

        if (strProps === strNextProps) {
            return false;
        }

        return true;
    }

    render() {
        const { countryAlpha3Code, regions } = this.props;

        const mapSvg = countryAlpha3Code;

        if (!mapSvg) {
            return undefined;
        }
        return (
            <span
                style={{ display: "block", width: "100%", height: "100%" }}
                ref={span => {
                    if (!span) return;
                    span.innerHTML = mapSvg;
                    const svg = span.querySelector("svg");
                    const bbox = svg.getBBox();
                    svg.setAttribute("viewBox", `${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}`);
                    Object.keys(regions).forEach(regionCode => {
                        const data = regions[regionCode];
                        const path: SVGPathElement = span.querySelector(`#${regionCode}`);

                        if (path) {
                            path.style.fill = data.color;
                            path.attributes["description"] = data.value;
                            path.classList.add(`bin-${data.bin}`);
                        }
                    });
                    const allPaths: SVGPathElement[] = Array.from(span.querySelectorAll(`.land`));
                    allPaths.forEach(path => {
                        const hasClass: boolean = Object.keys(regions).some(regionCode => {
                            const data = regions[regionCode];
                            return path.classList.contains(`bin-${data.bin}`);
                        });

                        if (!hasClass) {
                            path.classList.add("hidden-path");
                        }
                    });
                }}
            />
        );
    }
}
